export const countryList = [
    {
        "label": "Please select...",
        "value": ""
    },
    {
        "label": "American Samoa",
        "value": 5
    },
    {
        "label": "Anguilla ",
        "value": 8
    },
    {
        "label": "Antarctica",
        "value": 9
    },
    {
        "label": "Aruba",
        "value": 13
    },
    {
        "label": "Bermuda ",
        "value": 25
    },
    {
        "label": "Bouvet Island (Territory of Norway)",
        "value": 30
    },
    {
        "label": "British Indian Ocean Territory (BIOT)",
        "value": 32
    },
    {
        "label": "Cayman Islands ",
        "value": 41
    },
    {
        "label": "Christmas Island ",
        "value": 46
    },
    {
        "label": "Cocos (Keeling) Islands ",
        "value": 47
    },
    {
        "label": "Cook Islands (Former Harvey Islands)",
        "value": 52
    },
    {
        "label": "Cote D'Ivoire (Former Ivory Coast) ",
        "value": 54
    },
    {
        "label": "Czechoslavakia (Former) See CZ Czech Republic or Slovakia",
        "value": 59
    },
    {
        "label": "Falkland Islands (Islas Malvinas) ",
        "value": 72
    },
    {
        "label": "Faroe Islands ",
        "value": 73
    },
    {
        "label": "Finland ",
        "value": 75
    },
    {
        "label": "French Guiana or French Guyana ",
        "value": 77
    },
    {
        "label": "French Polynesia (Former French Colony of Oceania)",
        "value": 78
    },
    {
        "label": "French Southern Territories and Antarctic Lands ",
        "value": 79
    },
    {
        "label": "Gambia, The ",
        "value": 81
    },
    {
        "label": "Gibraltar ",
        "value": 85
    },
    {
        "label": "Greenland ",
        "value": 88
    },
    {
        "label": "Guadeloupe",
        "value": 90
    },
    {
        "label": "Guam",
        "value": 91
    },
    {
        "label": "Heard Island and McDonald Islands (Territory of Australia)",
        "value": 97
    },
    {
        "label": "Iran, Islamic Republic of",
        "value": 105
    },
    {
        "label": "Korea, Democratic People's Republic of (North Korea)",
        "value": 116
    },
    {
        "label": "Lao People's Democratic Republic (Laos)",
        "value": 120
    },
    {
        "label": "Macau ",
        "value": 129
    },
    {
        "label": "Martinique (French) ",
        "value": 138
    },
    {
        "label": "Mayotte (Territorial Collectivity of Mayotte)",
        "value": 141
    },
    {
        "label": "Monaco, Principality of",
        "value": 145
    },
    {
        "label": "Montserrat ",
        "value": 147
    },
    {
        "label": "Netherlands Antilles (Former Curacao and Dependencies)",
        "value": 155
    },
    {
        "label": "New Caledonia ",
        "value": 156
    },
    {
        "label": "New Zealand (Aotearoa) ",
        "value": 157
    },
    {
        "label": "Norfolk Island ",
        "value": 162
    },
    {
        "label": "Northern Mariana Islands (Former Mariana Islands District - Trust Territory of the Pacific Islands)",
        "value": 163
    },
    {
        "label": "Norway ",
        "value": 164
    },
    {
        "label": "Oman, Sultanate of (Former Muscat and Oman)",
        "value": 165
    },
    {
        "label": "Palestinian State (Proposed)",
        "value": 168
    },
    {
        "label": "Pitcairn Island",
        "value": 174
    },
    {
        "label": "Puerto Rico ",
        "value": 177
    },
    {
        "label": "Qatar, State of ",
        "value": 178
    },
    {
        "label": "Reunion (French) (Former Bourbon Island)",
        "value": 179
    },
    {
        "label": "Russian Federation ",
        "value": 182
    },
    {
        "label": "Saint Helena ",
        "value": 184
    },
    {
        "label": "Saint Pierre and Miquelon ",
        "value": 187
    },
    {
        "label": "South Georgia and the South Sandwich Islands",
        "value": 203
    },
    {
        "label": "Svalbard (Spitzbergen) and Jan Mayen Islands ",
        "value": 208
    },
    {
        "label": "Tokelau ",
        "value": 218
    },
    {
        "label": "Tromelin Island ",
        "value": 221
    },
    {
        "label": "Turks and Caicos Islands ",
        "value": 225
    },
    {
        "label": "United States Minor Outlying Islands ",
        "value": 232
    },
    {
        "label": "Uruguay, Oriental Republic of (Former Banda Oriental, Cisplatine Province)",
        "value": 233
    },
    {
        "label": "Vanuatu (Former New Hebrides)",
        "value": 235
    },
    {
        "label": "Virgin Islands, British ",
        "value": 239
    },
    {
        "label": "Virgin Islands, United States (Former Danish West Indies) ",
        "value": 240
    },
    {
        "label": "Wallis and Futuna Islands ",
        "value": 241
    },
    {
        "label": "Western Sahara (Former Spanish Sahara)",
        "value": 242
    },
    {
        "label": "Yugoslavia ",
        "value": 244
    },
    {
        "label": "Zaire (Former Congo Free State, Belgian Congo, Congo/Leopoldville, Congo/Kinshasa, Zaire) Now CD - Congo, Democratic Republic of the ",
        "value": 245
    },
    {
        "label": "Afghanistan ",
        "value": 2
    },
    {
        "label": "Albania ",
        "value": 3
    },
    {
        "label": "Algeria ",
        "value": 4
    },
    {
        "label": "Andorra, Principality of ",
        "value": 6
    },
    {
        "label": "Angola",
        "value": 7
    },
    {
        "label": "Antigua and Barbuda",
        "value": 10
    },
    {
        "label": "Argentina ",
        "value": 11
    },
    {
        "label": "Armenia",
        "value": 12
    },
    {
        "label": "Australia",
        "value": 14
    },
    {
        "label": "Austria",
        "value": 15
    },
    {
        "label": "Azerbaijan or Azerbaidjan (Former Azerbaijan Soviet Socialist Republic)",
        "value": 16
    },
    {
        "label": "Bahamas, Commonwealth of The",
        "value": 17
    },
    {
        "label": "Bahrain, Kingdom of (Former Dilmun)",
        "value": 18
    },
    {
        "label": "Bangladesh (Former East Pakistan)",
        "value": 19
    },
    {
        "label": "Barbados ",
        "value": 20
    },
    {
        "label": "Belarus (Former Belorussian [Byelorussian] Soviet Socialist Republic)",
        "value": 21
    },
    {
        "label": "Belgium ",
        "value": 22
    },
    {
        "label": "Belize (Former British Honduras)",
        "value": 23
    },
    {
        "label": "Benin (Former Dahomey)",
        "value": 24
    },
    {
        "label": "Bhutan, Kingdom of",
        "value": 26
    },
    {
        "label": "Bolivia ",
        "value": 27
    },
    {
        "label": "Bosnia and Herzegovina ",
        "value": 28
    },
    {
        "label": "Botswana (Former Bechuanaland)",
        "value": 29
    },
    {
        "label": "Brazil ",
        "value": 31
    },
    {
        "label": "Brunei (Negara Brunei Darussalam) ",
        "value": 33
    },
    {
        "label": "Bulgaria ",
        "value": 34
    },
    {
        "label": "Burkina Faso (Former Upper Volta)",
        "value": 35
    },
    {
        "label": "Burundi (Former Urundi)",
        "value": 36
    },
    {
        "label": "Cambodia, Kingdom of (Former Khmer Republic, Kampuchea Republic)",
        "value": 37
    },
    {
        "label": "Cameroon (Former French Cameroon)",
        "value": 38
    },
    {
        "label": "Canada ",
        "value": 39
    },
    {
        "label": "Cape Verde ",
        "value": 40
    },
    {
        "label": "Central African Republic ",
        "value": 42
    },
    {
        "label": "Chad ",
        "value": 43
    },
    {
        "label": "Chile ",
        "value": 44
    },
    {
        "label": "China ",
        "value": 45
    },
    {
        "label": "Colombia ",
        "value": 48
    },
    {
        "label": "Comoros, Union of the ",
        "value": 49
    },
    {
        "label": "Congo, Democratic Republic of the (Former Zaire) ",
        "value": 50
    },
    {
        "label": "Congo, Republic of the",
        "value": 51
    },
    {
        "label": "Costa Rica ",
        "value": 53
    },
    {
        "label": "Croatia (Hrvatska) ",
        "value": 55
    },
    {
        "label": "Cuba ",
        "value": 56
    },
    {
        "label": "Cyprus ",
        "value": 57
    },
    {
        "label": "Czech Republic",
        "value": 58
    },
    {
        "label": "Denmark ",
        "value": 60
    },
    {
        "label": "Djibouti (Former French Territory of the Afars and Issas, French Somaliland)",
        "value": 61
    },
    {
        "label": "Dominica ",
        "value": 62
    },
    {
        "label": "Dominican Republic ",
        "value": 63
    },
    {
        "label": "East Timor (Former Portuguese Timor)",
        "value": 64
    },
    {
        "label": "Ecuador ",
        "value": 65
    },
    {
        "label": "Egypt (Former United Arab Republic - with Syria)",
        "value": 66
    },
    {
        "label": "El Salvador ",
        "value": 67
    },
    {
        "label": "Equatorial Guinea (Former Spanish Guinea)",
        "value": 68
    },
    {
        "label": "Eritrea (Former Eritrea Autonomous Region in Ethiopia)",
        "value": 69
    },
    {
        "label": "Estonia (Former Estonian Soviet Socialist Republic)",
        "value": 70
    },
    {
        "label": "Ethiopia (Former Abyssinia, Italian East Africa)",
        "value": 71
    },
    {
        "label": "Fiji ",
        "value": 74
    },
    {
        "label": "France ",
        "value": 76
    },
    {
        "label": "Gabon (Gabonese Republic)",
        "value": 80
    },
    {
        "label": "Georgia (Former Georgian Soviet Socialist Republic)",
        "value": 82
    },
    {
        "label": "Germany ",
        "value": 83
    },
    {
        "label": "Ghana (Former Gold Coast)",
        "value": 84
    },
    {
        "label": "Great Britain (United Kingdom) ",
        "value": 86
    },
    {
        "label": "Greece ",
        "value": 87
    },
    {
        "label": "Grenada ",
        "value": 89
    },
    {
        "label": "Guatemala ",
        "value": 92
    },
    {
        "label": "Guinea (Former French Guinea)",
        "value": 93
    },
    {
        "label": "Guinea-Bissau (Former Portuguese Guinea)",
        "value": 94
    },
    {
        "label": "Guyana (Former British Guiana)",
        "value": 95
    },
    {
        "label": "Haiti ",
        "value": 96
    },
    {
        "label": "Holy See (Vatican City State)",
        "value": 98
    },
    {
        "label": "Honduras ",
        "value": 99
    },
    {
        "label": "Hong Kong ",
        "value": 100
    },
    {
        "label": "Hungary ",
        "value": 101
    },
    {
        "label": "Iceland ",
        "value": 102
    },
    {
        "label": "India ",
        "value": 103
    },
    {
        "label": "Indonesia (Former Netherlands East Indies; Dutch East Indies)",
        "value": 104
    },
    {
        "label": "Iraq ",
        "value": 106
    },
    {
        "label": "Ireland ",
        "value": 107
    },
    {
        "label": "Israel ",
        "value": 108
    },
    {
        "label": "Italy ",
        "value": 109
    },
    {
        "label": "Jamaica ",
        "value": 110
    },
    {
        "label": "Japan ",
        "value": 111
    },
    {
        "label": "Jordan (Former Transjordan)",
        "value": 112
    },
    {
        "label": "Kazakstan or Kazakhstan (Former Kazakh Soviet Socialist Republic)",
        "value": 113
    },
    {
        "label": "Kenya (Former British East Africa)",
        "value": 114
    },
    {
        "label": "Kiribati (Pronounced keer-ree-bahss) (Former Gilbert Islands)",
        "value": 115
    },
    {
        "label": "Korea, Republic of (South Korea) ",
        "value": 117
    },
    {
        "label": "Kuwait ",
        "value": 118
    },
    {
        "label": "Kyrgyzstan (Kyrgyz Republic) (Former Kirghiz Soviet Socialist Republic)",
        "value": 119
    },
    {
        "label": "Latvia (Former Latvian Soviet Socialist Republic)",
        "value": 121
    },
    {
        "label": "Lebanon ",
        "value": 122
    },
    {
        "label": "Lesotho (Former Basutoland)",
        "value": 123
    },
    {
        "label": "Liberia ",
        "value": 124
    },
    {
        "label": "Libya (Libyan Arab Jamahiriya)",
        "value": 125
    },
    {
        "label": "Liechtenstein ",
        "value": 126
    },
    {
        "label": "Lithuania (Former Lithuanian Soviet Socialist Republic)",
        "value": 127
    },
    {
        "label": "Luxembourg ",
        "value": 128
    },
    {
        "label": "Macedonia, The Former Yugoslav Republic of",
        "value": 130
    },
    {
        "label": "Madagascar (Former Malagasy Republic)",
        "value": 131
    },
    {
        "label": "Malawi (Former British Central African Protectorate, Nyasaland)",
        "value": 132
    },
    {
        "label": "Malaysia ",
        "value": 133
    },
    {
        "label": "Maldives ",
        "value": 134
    },
    {
        "label": "Mali (Former French Sudan and Sudanese Republic) ",
        "value": 135
    },
    {
        "label": "Malta ",
        "value": 136
    },
    {
        "label": "Marshall Islands (Former Marshall Islands District - Trust Territory of the Pacific Islands)",
        "value": 137
    },
    {
        "label": "Mauritania ",
        "value": 139
    },
    {
        "label": "Mauritius ",
        "value": 140
    },
    {
        "label": "Mexico ",
        "value": 142
    },
    {
        "label": "Micronesia, Federated States of (Former Ponape, Truk, and Yap Districts - Trust Territory of the Pacific Islands)",
        "value": 143
    },
    {
        "label": "Moldova, Republic of",
        "value": 144
    },
    {
        "label": "Mongolia (Former Outer Mongolia)",
        "value": 146
    },
    {
        "label": "Morocco ",
        "value": 148
    },
    {
        "label": "Mozambique (Former Portuguese East Africa)",
        "value": 149
    },
    {
        "label": "Myanmar, Union of (Former Burma)",
        "value": 150
    },
    {
        "label": "Namibia (Former German Southwest Africa, South-West Africa)",
        "value": 151
    },
    {
        "label": "Nauru (Former Pleasant Island)",
        "value": 152
    },
    {
        "label": "Nepal ",
        "value": 153
    },
    {
        "label": "Netherlands ",
        "value": 154
    },
    {
        "label": "Nicaragua ",
        "value": 158
    },
    {
        "label": "Niger ",
        "value": 159
    },
    {
        "label": "Nigeria ",
        "value": 160
    },
    {
        "label": "Niue (Former Savage Island)",
        "value": 161
    },
    {
        "label": "Pakistan (Former West Pakistan)",
        "value": 166
    },
    {
        "label": "Palau (Former Palau District - Trust Terriroty of the Pacific Islands)",
        "value": 167
    },
    {
        "label": "Panama ",
        "value": 169
    },
    {
        "label": "Papua New Guinea (Former Territory of Papua and New Guinea)",
        "value": 170
    },
    {
        "label": "Paraguay ",
        "value": 171
    },
    {
        "label": "Peru ",
        "value": 172
    },
    {
        "label": "Philippines ",
        "value": 173
    },
    {
        "label": "Poland ",
        "value": 175
    },
    {
        "label": "Portugal ",
        "value": 176
    },
    {
        "label": "Romania ",
        "value": 180
    },
    {
        "label": "Russia - USSR (Former Russian Empire, Union of Soviet Socialist Republics, Russian Soviet Federative Socialist Republic) Now RU - Russian Federation",
        "value": 181
    },
    {
        "label": "Rwanda (Rwandese Republic) (Former Ruanda)",
        "value": 183
    },
    {
        "label": "Saint Kitts and Nevis (Former Federation of Saint Christopher and Nevis)",
        "value": 185
    },
    {
        "label": "Saint Lucia ",
        "value": 186
    },
    {
        "label": "Saint Vincent and the Grenadines ",
        "value": 188
    },
    {
        "label": "Samoa (Former Western Samoa)",
        "value": 189
    },
    {
        "label": "San Marino ",
        "value": 190
    },
    {
        "label": "Sao Tome and Principe ",
        "value": 191
    },
    {
        "label": "Saudi Arabia ",
        "value": 192
    },
    {
        "label": "Serbia, Republic of",
        "value": 193
    },
    {
        "label": "Senegal ",
        "value": 194
    },
    {
        "label": "Seychelles ",
        "value": 195
    },
    {
        "label": "Sierra Leone ",
        "value": 196
    },
    {
        "label": "Singapore ",
        "value": 197
    },
    {
        "label": "Slovakia",
        "value": 198
    },
    {
        "label": "Slovenia ",
        "value": 199
    },
    {
        "label": "Solomon Islands (Former British Solomon Islands)",
        "value": 200
    },
    {
        "label": "Somalia (Former Somali Republic, Somali Democratic Republic) ",
        "value": 201
    },
    {
        "label": "South Africa (Former Union of South Africa)",
        "value": 202
    },
    {
        "label": "Spain ",
        "value": 204
    },
    {
        "label": "Sri Lanka (Former Serendib, Ceylon) ",
        "value": 205
    },
    {
        "label": "Sudan (Former Anglo-Egyptian Sudan) ",
        "value": 206
    },
    {
        "label": "Suriname (Former Netherlands Guiana, Dutch Guiana)",
        "value": 207
    },
    {
        "label": "Swaziland, Kingdom of ",
        "value": 209
    },
    {
        "label": "Sweden ",
        "value": 210
    },
    {
        "label": "Switzerland ",
        "value": 211
    },
    {
        "label": "Syria (Syrian Arab Republic) (Former United Arab Republic - with Egypt)",
        "value": 212
    },
    {
        "label": "Taiwan (Former Formosa)",
        "value": 213
    },
    {
        "label": "Tajikistan (Former Tajik Soviet Socialist Republic)",
        "value": 214
    },
    {
        "label": "Tanzania, United Republic of (Former United Republic of Tanganyika and Zanzibar)",
        "value": 215
    },
    {
        "label": "Thailand (Former Siam)",
        "value": 216
    },
    {
        "label": "Togo (Former French Togoland)",
        "value": 217
    },
    {
        "label": "Tonga, Kingdom of (Former Friendly Islands)",
        "value": 219
    },
    {
        "label": "Trinidad and Tobago ",
        "value": 220
    },
    {
        "label": "Tunisia ",
        "value": 222
    },
    {
        "label": "Turkey ",
        "value": 223
    },
    {
        "label": "Turkmenistan (Former Turkmen Soviet Socialist Republic)",
        "value": 224
    },
    {
        "label": "Tuvalu (Former Ellice Islands)",
        "value": 226
    },
    {
        "label": "Uganda, Republic of",
        "value": 227
    },
    {
        "label": "Ukraine (Former Ukrainian National Republic, Ukrainian State, Ukrainian Soviet Socialist Republic)",
        "value": 228
    },
    {
        "label": "United Arab Emirates (UAE) (Former Trucial Oman, Trucial States)",
        "value": 229
    },
    {
        "label": "United Kingdom (Great Britain / UK)",
        "value": 230
    },
    {
        "label": "United States ",
        "value": 231
    },
    {
        "label": "Uzbekistan (Former UZbek Soviet Socialist Republic)",
        "value": 234
    },
    {
        "label": "Vatican City State (Holy See)",
        "value": 236
    },
    {
        "label": "Venezuela ",
        "value": 237
    },
    {
        "label": "Vietnam ",
        "value": 238
    },
    {
        "label": "Yemen ",
        "value": 243
    },
    {
        "label": "Zambia, Republic of (Former Northern Rhodesia) ",
        "value": 246
    },
    {
        "label": "Zimbabwe, Republic of (Former Southern Rhodesia, Rhodesia) ",
        "value": 247
    }
]